import SecureLinkMember from './SecureLinkMember.component';

export default SecureLinkMember;